// Client-side notification category list. `id` must match the backend
// registry (functions/notifications/helpers/registry.py); the account page
// renders one toggle per entry, so a future category is one new entry here
// plus its registry default on the backend.
export const notificationCategories = [
  {
    id: "session-starter",
    labelKey: "account.notifications.sessionStarter.label",
    descriptionKey: "account.notifications.sessionStarter.description",
  },
];
